import { BReactComponent } from 'blocks-cloud/b-react-component';
import app from 'Cloud/Application/app';
import browser from 'Cloud/browser';
import config from 'Cloud/config';
import $ from 'jquery';
import { getCurrentPublicFolder, getPublicOwner, isPublicUploadEnabled } from 'reactApp/modules/public/public.selectors';
import { store } from 'reactApp/store';
import { PublicUploadHeader } from 'reactApp/ui/PublicUploadHeader/PublicUploadHeader';
import { renderUploadDialog } from 'reactApp/ui/UploadDialog/UploadDialog.helpers';
import { createAvatarUrl } from 'reactApp/utils/avatar';
import { sendGa } from 'reactApp/utils/ga';

const IS_WEBVIEW = config.get('IS_WEBVIEW');
let isRendered = false;

export const isPublicUpload = () => isPublicUploadEnabled(store.getState());

export const isEnabled = () => !(browser.isPhone() || IS_WEBVIEW) && app.isPublic() && isPublicUpload();

export const renderPublicUpload = () => {
    if (isRendered) {
        return;
    }

    const component = new BReactComponent({
        ReactComponent: PublicUploadHeader,
        renderMode: 'append',
    });

    const publicOwner = getPublicOwner(store.getState());

    const { email, first_name: firstName, last_name: lastName, nick } = publicOwner;

    document.body.classList.add('body_public-upload');

    isRendered = true;

    component.renderTo($('#react-public-upload'), {
        props: {
            firstName,
            lastName,
            nick,
            ownerEmail: email,
            avatar: createAvatarUrl(email, email, 40),
            onUploadClick: () => {
                if (app.user.isAuthorized()) {
                    const folder = getCurrentPublicFolder(store.getState()); // не используем переменую выше, ибо нам нужна текущая папка. А там папка на момент захода в паблик

                    renderUploadDialog({
                        folderId: folder.id,
                        folderHome: folder.home,
                        folderName: folder.name,
                        setInputs: app.upload.setInputs,
                        openFrom: 'public',
                    });
                } else {
                    app.ui.login.show({
                        closable: true,
                    });
                }
            },
        },
    });
};

export const sendPublicUploadRadar = () => {
    const isPaidUser = app.user.isPaidUser();
    const isAnonymous = !app.user || !app.user.isAuthorized();

    let gaLabel = 'free';

    if (isAnonymous) {
        gaLabel = 'anon';
    } else if (isPaidUser) {
        gaLabel = 'paid';
    }

    sendGa('public-upload', 'user-type', gaLabel);
};
